export enum FormType {
    contractSales = 'contractSales',
    brandGuide = 'brandGuide',
    whitePaper = 'whitePaper',
    bookDemo = 'bookDemo',
}

export enum ChannelType {
    brandGuide = 7,
    whitePaper = 4,
}

export interface IProp {
    type: FormType;
    referUrl: string;
    platform: 'twww' | 'mobile'; // 平台
    downloadUrl?: string;
    changeHasSubmitted?: Function;
    contentComponent?: React.FunctionComponent<any> | React.ComponentClass<any, any>;
}

export interface OptionItemType {
    id: string;
    label: string;
}

export interface ParamsType {
    first_name: string;
    last_name: string;
    phone: string;
    email: string;
    department: string;
    staff_count: string;
    how_hear_about_us: string;
    receive_subscribe: string | number;
    enterprise_name: string;
    position_name: string;
    source: string;
    description: string;
    channel_type?: number;
}
